import invent from "../assets/invent.jpeg";


// import TestIMG1 from "../../../assets/images/banner/1.png";
// import TestIMG2 from "../../../assets/images/banner/2.png";

const teamMembersDatas = [
    {
        id: 1,
        name: "Moean Uddin",
        role: "CEO",
        image: invent

    },
    {
        id: 2,
        name: "Monir",
        role: "CEO",
        // "image": TestIMG2

    }
]

export { teamMembersDatas }